import { configureStore } from "redux-starter-kit";
import emailCaptureOverlayReducer from "./ducks/email-capture-overlay";
import feedFiltersReducer from "./ducks/feed-filters";
import feedSidebarReducer from "./ducks/feed-sidebar";
import signupOverlayReducer from "./ducks/signup-overlay";
import appHeaderSearchReducer from "./ducks/app-header-search";
import appHeaderCartReducer from "./ducks/app-header-cart";
import shippingAndReturnsOverlayReducer from "./ducks/shipping-and-returns-overlay";
import feedShowMoreReducer from "./ducks/feed-show-more";
import feedSeoContentReducer from "./ducks/feed-seo-content";

const store = configureStore({
    reducer: {
        emailCaptureOverlayReducer,
        feedFiltersReducer,
        feedSidebarReducer,
        signupOverlayReducer,
        appHeaderSearchReducer,
        appHeaderCartReducer,
        shippingAndReturnsOverlayReducer,
        feedShowMoreReducer,
        feedSeoContentReducer,
    },
});

export type ReduxStoreState = ReturnType<typeof store["getState"]>;

export default store;
